import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import { Gama } from '../models/Gama';
import { Order, OrderWithGamas } from '../models/Order';
import { DateService } from './date.service';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private dateService: DateService) {}

  doc = new jsPDF()
  margins: {
    start: {x: number, y: number},
    text:{x: number, y: number}
  } = {
    start: {x: 5, y: 6},
    text: {x: 2, y: 4}
  }
  pageWidth = this.doc.internal.pageSize.getWidth() - (this.margins.start.x*2) //margenes
  pageHeight = this.doc.internal.pageSize.getHeight() //margenes
  cellHeight = 5

  resetPDF(){
    this.doc = new jsPDF()
    this.margins = {
      start: {x: 5, y: 6},
      text:{x: 2, y: 4}
    }
  }

  async saveAllOrderGamasPDF(order: OrderWithGamas){
    this.resetPDF()

    console.log("order", order)
    const ordered_gamas: Gama[] = order.gamas.sort((a, b) => a.index - b.index)
    console.log("ordered gamas", ordered_gamas)
    for(let gama of ordered_gamas){
      await this.generateGammaPDF(gama, order)
      this.margins.start.y = this.margins.start.y + this.cellHeight*5 + this.cellHeight*2 + this.cellHeight*(gama.operations.length+1) + this.cellHeight*(gama.materials.length+1) + this.cellHeight*2
      const gama_index: number = ordered_gamas.findIndex(gama_aux => gama.id === gama_aux.id)
      if( gama_index < order.gamas.length - 1){ //Si no es el último añadimos un salto de página ó una línea divisoria horizontal dependiendo de si es par o impar
        if(gama_index % 2 === 1){ //Si es impar, añadimos un salto de página
          this.doc.addPage()
          this.margins.start.y = 6
        }
        else{ //Si es par, añadimos una línea divisoria horizontal
          this.doc.setLineWidth(0.2); // Establecer el grosor de la línea
          this.doc.setDrawColor(0, 0, 0); // Establecer el color de la línea a negro
          this.doc.setLineDashPattern([1, 2], 0); // Establecer el patrón de la línea discontinua (1 unidad de línea, 2 unidades de espacio)
          this.doc.line(this.margins.start.x, this.pageHeight/2, this.margins.start.x + this.pageWidth, this.pageHeight/2); // Dibujar la línea
          this.doc.setLineDashPattern([], 0)

          this.margins.start.y = this.pageHeight/2 + 6
        }
      }
      console.log("generada gama", gama.index)
    }
    this.doc.save('Gamas_OT_' + order.number.replace('/', '-') + '.pdf')
  }


  async saveGamaPDF(gama: Gama, order: OrderWithGamas){
    this.resetPDF()
    await this.generateGammaPDF(gama, order)
    this.doc.save(`Gama_${order.number.replace('/', '-')}_${gama.index}.pdf`)
  }

  async generateGammaPDF(gama: Gama, order: OrderWithGamas){
    await this.addDocumentHeader(gama, order)
    await this.addDocumentOperations(gama)
    await this.addDocumentControls(gama)
    await this.addDocumentMaterials(gama)
    await this.generateDocumentFooter(gama)
  }

  async addDocumentHeader(gama: Gama, order: OrderWithGamas){
    const gama_index: number = order.gamas.findIndex(gama_aux => gama.id === gama_aux.id) + 1
    //Definimos anchos de las columnas
    const col_1_width = (this.pageWidth * 2) / 6;
    const col_2_width = this.pageWidth / 6;
    const col_3_width = this.pageWidth / 6;
    const col_4_width = this.pageWidth / 6;
    const col_5_width = this.pageWidth / 6;
    let start_y = this.margins.start.y; // Starting Y position

    // Rectángulos
    this.doc.rect(this.margins.start.x, start_y, col_1_width, this.cellHeight); // First column
    this.doc.rect(this.margins.start.x + col_1_width, start_y, col_2_width, this.cellHeight*5); // Second column
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width, start_y, col_3_width, this.cellHeight*5); // Third column
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width, start_y, col_4_width, this.cellHeight); // Fourth column
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width, start_y, col_5_width, this.cellHeight); // Fifth column

    // Texto de la cabecera
    const text_1 = 'DESIGNACIÓN:';
    const text_3 = 'O.T.:';
    const text_4 = order.number;
   
    // Seteamos el tamaño de la fuente y añadimos el texto
    this.doc.setFontSize(this.calculateFontSize(text_1, col_1_width));
    this.doc.text(text_1, this.margins.start.x + this.margins.text.x, start_y + this.margins.text.y)

    this.doc.setFontSize(this.calculateFontSize(text_3, col_4_width));
    this.doc.text(text_3, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

    this.doc.setFontSize(this.calculateFontSize(text_4, col_5_width));
    this.doc.text(text_4, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width+ this.margins.text.x, start_y + this.margins.text.y)

    //Añadimos el código QR
    const qr_code_witdh = (col_2_width > this.cellHeight*5 ? this.cellHeight*5 : col_2_width) - this.margins.start.x //Devolvemos el menor de los dos valores para que entre en el recuadro. El código QR es cuadrado así que el ancho y el alto son iguales
    const qr_code_url = await this.generateQRCode(gama, qr_code_witdh) //Generamos el código QR
    const qr_code_position_x_margin: number = (col_2_width - qr_code_witdh) / 2 //La posición x del código QR es la mitad de la diferencia entre el ancho de la columna y el ancho del código QR
    const qr_code_position_y_margin: number = (this.cellHeight*5 - qr_code_witdh) / 2 //La posición y del código QR es la mitad de la diferencia entre el alto de la celda y el alto del código QR

    this.doc.addImage(qr_code_url, 'PNG', this.margins.start.x + col_1_width + qr_code_position_x_margin, this.margins.start.y + qr_code_position_y_margin, qr_code_witdh, qr_code_witdh)


    //Añadimos la imagen del logo
    const imgData = await this.getBase64ImageFromURL('../../assets/imgs/logos/logo.png');
    this.doc.addImage(imgData, 'PNG', this.margins.start.x + col_1_width + col_2_width, this.margins.start.y, col_3_width, this.cellHeight*5);

    //Add the designations
    for(let i = 0; i < 4; i++){
      start_y += this.cellHeight
      // Añadimos rectangulos
      this.doc.rect(this.margins.start.x, start_y, col_1_width, this.cellHeight)
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width, start_y, col_4_width, this.cellHeight)
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width, start_y, col_5_width, this.cellHeight)

      // Texto designacion correspondiente
      this.doc.setFontSize(this.calculateFontSize(gama.designations[i] || '', col_1_width));
      this.doc.text(gama.designations[i] || '', this.margins.start.x + this.margins.text.x, start_y + this.margins.text.y)

      //Otras columnas
      let text_col_3: string = ''
      let text_col_4: string = ''
      switch(i){
        case 0:
          text_col_3 = 'S/C o Pedido:  ' + gama.s_c_one
          text_col_4 = 'AFFAIRE:  ' + gama.affaire
          this.doc.setFontSize(this.calculateFontSize(text_col_3, col_4_width));
          this.doc.text(text_col_3, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

          this.doc.setFontSize(this.calculateFontSize(text_col_4, col_5_width));
          this.doc.text(text_col_4, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
          break
        case 1:
          text_col_3 = 'CLIENTE:'
          text_col_4 = order.client || ''
          this.doc.setFontSize(this.calculateFontSize(text_col_3, col_4_width));
          this.doc.text(text_col_3, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

          this.doc.setFontSize(this.calculateFontSize(text_col_4, col_5_width));
          this.doc.text(text_col_4, this.margins.start.x + col_1_width + col_2_width +  col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
          break
        case 2:
          text_col_3 = 'GAMA Nº:'
          text_col_4 = gama_index.toString() + '/' + order.gamas.length
          this.doc.setFontSize(this.calculateFontSize(text_col_3, col_4_width));
          this.doc.text(text_col_3, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

          this.doc.setFontSize(this.calculateFontSize(text_col_4, col_5_width));
          this.doc.text(text_col_4, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
          break
        case 3:
          text_col_3 = 'Plz. ENTREGA:'
          text_col_4 = order.deliver_date ? this.dateService.formatDate(order.deliver_date) : '-'
          this.doc.setFontSize(this.calculateFontSize(text_col_3, col_4_width));
          this.doc.text(text_col_3, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

          this.doc.setFontSize(this.calculateFontSize(text_col_4, col_5_width));
          this.doc.text(text_col_4, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
          break
      }
    }
  }

  addDocumentOperations(gama: Gama){
    //Definimos anchos de las columnas
    const col_1_width = this.pageWidth / 9;
    const col_2_width = this.pageWidth / 9;
    const col_3_width = this.pageWidth / 9;
    const col_4_width = (this.pageWidth * 5) / 9;
    const col_5_width = this.pageWidth / 9;
    let start_y = this.margins.start.y + this.cellHeight*5; // Starting Y position

    for(let i = 0; i < gama.operations.length + 1; i++){
      // Rectángulos
      this.doc.rect(this.margins.start.x, start_y, col_1_width, this.cellHeight); // First column
      this.doc.rect(this.margins.start.x + col_1_width, start_y, col_2_width, this.cellHeight); // Second column
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width, start_y, col_3_width, this.cellHeight); // Third column
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width, start_y, col_4_width, this.cellHeight); // Third column
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width, start_y, col_5_width, this.cellHeight); // Third column
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width, start_y, col_4_width, this.cellHeight); // Third column

      let text_col_1: string = ''
      let text_col_2: string = ''
      let text_col_3: string = ''
      let text_col_4: string = ''
      let text_col_5: string = ''
      switch(i){
        case 0:
          text_col_1 = 'FECHA'
          text_col_2 = 'NOMBRE'
          text_col_3 = 'MAQUINA'
          text_col_4 = 'OPERACIONES'
          text_col_5 = 'TIEMPO'
        break
        default:
          text_col_1 = gama.operations[i-1].date || ''
          text_col_2 = gama.operations[i-1].name || ''
          text_col_3 = gama.operations[i-1].machine || ''
          text_col_4 = gama.operations[i-1].operation || ''
          text_col_5 = gama.operations[i-1].time || ''
          break
      }
      this.doc.setFontSize(this.calculateFontSize(text_col_1, col_1_width));
      this.doc.text(text_col_1, this.margins.start.x +  this.margins.text.x, start_y + this.margins.text.y)
      
      this.doc.setFontSize(this.calculateFontSize(text_col_2, col_2_width));
      this.doc.text(text_col_2, this.margins.start.x + col_1_width + this.margins.text.x, start_y + this.margins.text.y)
      
      this.doc.setFontSize(this.calculateFontSize(text_col_3, col_3_width));
      this.doc.text(text_col_3, this.margins.start.x + col_1_width + col_2_width + this.margins.text.x, start_y + this.margins.text.y)

      this.doc.setFontSize(this.calculateFontSize(text_col_4, col_4_width));
      this.doc.text(text_col_4, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

      this.doc.setFontSize(this.calculateFontSize(text_col_5, col_5_width));
      this.doc.text(text_col_5, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
      
      start_y += this.cellHeight
    }
  }

  addDocumentControls(gama: Gama){
    //Definimos anchos de las columnas
    const col_1_width = this.pageWidth / 7;
    const col_2_width = this.pageWidth / 7;
    const col_3_width = this.pageWidth / 7;
    const col_4_width = this.pageWidth / 7;
    const col_5_width = this.pageWidth / 7;
    const col_6_width = this.pageWidth / 7;
    const col_7_width = this.pageWidth / 7;
    let start_y = this.margins.start.y + this.cellHeight*5 + this.cellHeight*(gama.operations.length+1); // Starting Y position

    // Rectángulos
    //Primera Fila de rectangulos
    this.doc.rect(this.margins.start.x, start_y, col_1_width, this.cellHeight*2)
    this.doc.rect(this.margins.start.x + col_1_width, start_y, col_2_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width, start_y, col_3_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width, start_y, col_4_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width, start_y, col_5_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width, start_y, col_6_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + col_6_width, start_y, col_7_width, this.cellHeight*2)

    // Texto de la cabecera
    let text_col_1: string = 'CONTROL'
    let text_col_2: string = ''
    let text_col_3: string = ''
    let text_col_4: string = ''
    let text_col_5: string = 'TRATAMIENTO'
    let text_col_6: string = 'APARATO Nº'
    let text_col_7: string = 'FIRMA CONTROL CALIDAD:'
    
    this.doc.setFontSize(this.calculateFontSize(text_col_1, col_1_width));
    this.doc.text(text_col_1, this.margins.start.x +  this.margins.text.x, start_y + this.margins.text.y)
    
    this.doc.setFontSize(this.calculateFontSize(text_col_2, col_2_width));
    this.doc.text(text_col_2, this.margins.start.x + col_1_width + this.margins.text.x, start_y + this.margins.text.y)
    
    this.doc.setFontSize(this.calculateFontSize(text_col_3, col_3_width));
    this.doc.text(text_col_3, this.margins.start.x + col_1_width + col_2_width + this.margins.text.x, start_y + this.margins.text.y)

    this.doc.setFontSize(this.calculateFontSize(text_col_4, col_4_width));
    this.doc.text(text_col_4, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

    this.doc.setFontSize(this.calculateFontSize(text_col_5, col_5_width));
    this.doc.text(text_col_5, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
    
    this.doc.setFontSize(this.calculateFontSize(text_col_6, col_6_width));
    this.doc.text(text_col_6, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + this.margins.text.x, start_y + this.margins.text.y)

    this.doc.setFontSize(this.calculateFontSize(text_col_7, col_7_width));
    this.doc.text(text_col_7, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + col_6_width + this.margins.text.x, start_y + this.margins.text.y)
     

    //Segunda fila de controles
    start_y += this.cellHeight

    //Segunda Fila de rectangulos
    this.doc.rect(this.margins.start.x + col_1_width, start_y, col_2_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width, start_y, col_3_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width, start_y, col_4_width, this.cellHeight)
    this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width, start_y, col_5_width, this.cellHeight)
    for(let i = 0; i < 5; i++) this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + (col_6_width/5)*i, start_y, col_6_width/5, this.cellHeight)
    
    text_col_1 = 'FINAL'
    text_col_5 = gama.treatment
    this.doc.setFontSize(this.calculateFontSize(text_col_1, col_1_width));

    this.doc.text(text_col_1, this.margins.start.x +  this.margins.text.x, start_y + this.margins.text.y)
    
    this.doc.setFontSize(this.calculateFontSize(text_col_5, col_5_width));
    this.doc.text(text_col_5, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
  }

  addDocumentMaterials(gama: Gama){
     //Definimos anchos de las columnas
     const col_1_width = this.pageWidth / 12;
     const col_2_width = this.pageWidth / 12;
     const col_3_width = (this.pageWidth * 4) / 12;
     const col_4_width = this.pageWidth / 12;
     const col_5_width = (this.pageWidth * 3) / 12;
     const col_6_width = (this.pageWidth * 2) / 12;
     let start_y = this.margins.start.y + this.cellHeight*5 + this.cellHeight*2 + this.cellHeight*(gama.operations.length+1); // Starting Y position
 
     for(let i = 0; i < gama.materials.length + 1; i++){
      // Rectángulos
      this.doc.rect(this.margins.start.x, start_y, col_1_width, this.cellHeight)
      this.doc.rect(this.margins.start.x + col_1_width, start_y, col_2_width, this.cellHeight)
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width, start_y, col_3_width, this.cellHeight)
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width, start_y, col_4_width, this.cellHeight)
      this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width, start_y, col_5_width, this.cellHeight)
      if(i === 0){
        this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width, start_y, col_6_width, this.cellHeight)
      }
      else{
        this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width, start_y, col_6_width/2, this.cellHeight)
        this.doc.rect(this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + col_6_width/2, start_y, col_6_width/2, this.cellHeight)
      }

      let text_col_1: string = ''
      let text_col_2: string = ''
      let text_col_3: string = ''
      let text_col_4: string = ''
      let text_col_5: string = ''
      let text_col_6: string = ''
      let text_col_7: string = ''
      switch(i){
        case 0:
          text_col_1 = 'S.'
          text_col_2 = 'REF'
          text_col_3 = 'MATERIALES'
          text_col_4 = 'KG.'
          text_col_5 = 'VALORACION'
          text_col_6 = 'UBICACION'
        break
        default:
          text_col_1 = gama.materials[i-1].s || ''
          text_col_2 = gama.materials[i-1].ref || ''
          text_col_3 = gama.materials[i-1].material || ''
          text_col_4 = gama.materials[i-1].weight || ''
          text_col_5 = gama.materials[i-1].review || ''
          text_col_6 = gama.materials[i-1].ubication.ubication_one || ''
          text_col_7 = gama.materials[i-1].ubication.ubication_two || ''
          break
      }
      this.doc.setFontSize(this.calculateFontSize(text_col_1, col_1_width));
      this.doc.text(text_col_1, this.margins.start.x +  this.margins.text.x, start_y + this.margins.text.y)
      
      this.doc.setFontSize(this.calculateFontSize(text_col_2, col_2_width));
      this.doc.text(text_col_2, this.margins.start.x + col_1_width + this.margins.text.x, start_y + this.margins.text.y)
      
      this.doc.setFontSize(this.calculateFontSize(text_col_3, col_3_width));
      this.doc.text(text_col_3, this.margins.start.x + col_1_width + col_2_width + this.margins.text.x, start_y + this.margins.text.y)

      this.doc.setFontSize(this.calculateFontSize(text_col_4, col_4_width));
      this.doc.text(text_col_4, this.margins.start.x + col_1_width + col_2_width + col_3_width + this.margins.text.x, start_y + this.margins.text.y)

      this.doc.setFontSize(this.calculateFontSize(text_col_5, col_5_width));
      this.doc.text(text_col_5, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + this.margins.text.x, start_y + this.margins.text.y)
      
      if(i === 0){
        this.doc.setFontSize(this.calculateFontSize(text_col_6, col_6_width));
        this.doc.text(text_col_6, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + this.margins.text.x, start_y + this.margins.text.y)
      }
      else{
        this.doc.setFontSize(this.calculateFontSize(text_col_6, col_6_width/2));
        this.doc.text(text_col_6, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + this.margins.text.x, start_y + this.margins.text.y)

        this.doc.setFontSize(this.calculateFontSize(text_col_7, col_6_width/2));
        this.doc.text(text_col_7, this.margins.start.x + col_1_width + col_2_width + col_3_width + col_4_width + col_5_width + col_6_width/2 + this.margins.text.x, start_y + this.margins.text.y)
      }
      
      start_y += this.cellHeight
    }
  }

  generateDocumentFooter(gama: Gama){
    let start_y = this.margins.start.y + this.cellHeight*5 + this.cellHeight*2 + this.cellHeight*(gama.operations.length + gama.materials.length + 2); // Starting Y position
    this.doc.text(`RE0702	Y:\\9499\\gamas.docx`, this.margins.start.x, start_y + this.margins.text.y)
  }

  generateQRCode(gama: Gama, width: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      
      QRCode.toCanvas(canvas, gama.id, { width, margin: 1 }, (error) => {
        if (error) {
          console.error("Error creating QR Code", error);
          reject(error);
          return;
        }
        
        const qrCodeDataURL = canvas.toDataURL('image/png');
        resolve(qrCodeDataURL);
      });
    });
  }

  generateBarcode(gama: Gama){
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, gama.id, {
      format: 'CODE128',
      displayValue: true,
      fontSize: 18
    });

    const barcode = canvas.toDataURL('image/png')
    const barcode_position = this.margins.start.y + this.cellHeight*5 + this.cellHeight*2 + this.cellHeight*(gama.operations.length+1) + this.cellHeight*(gama.materials.length+1) + this.cellHeight*0.2

    this.doc.addImage(barcode, 'PNG', this.margins.start.x + this.pageWidth/6, barcode_position, this.pageWidth/1.5 , 15); // Ajusta las coordenadas y el tamaño según sea necesario
  }

  calculateFontSize(text: string, colWidth: number){
    const maxFontSize = 10; // Maximum font size
    const minFontSize = 5; // Minimum font size
    let fontSize = maxFontSize;

    while (fontSize > minFontSize) {
      this.doc.setFontSize(fontSize);
      const textWidth = this.doc.getTextWidth(text);
      if (textWidth <= colWidth - 4) { // Subtracting padding
        break;
      }
      fontSize -= 0.5;
    }

    return fontSize;
  };

  getBase64ImageFromURL(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      img.onload = () => {
        let canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0);
        let dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = (error) => {
        reject(error);
      };
    });
  }
}
